import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function BikeResolver() {
  const { numero } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/bikes/by-number/${encodeURIComponent(numero)}`);
        navigate(`/bici/${res.data.id}`, { replace: true });
      } catch (e) {
        toast.error(`Nessuna bici con numero "${numero}"`);
        navigate("/", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, [numero]);
  return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="h-7 w-7 animate-spin text-[#f98125]" /></div>;
}
